// サイドバーの収縮管理
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import setCookie from './functions/_cookie-setCookie.js' // Cookie発行

const pageBase = document.getElementById('pageBase')
const sidebarToggle = document.getElementById('sidebarToggle')
let sidebarMin = parseInt(getCookie('sidebarMin'), 10) // Cookie取得

if (sidebarToggle) {
  applySidebarSize(sidebarMin)
  sidebarToggle.addEventListener('click', function (e) {
    sidebarMin = !sidebarMin // フラグを反転
    setCookie('sidebarMin', sidebarMin ? 1 : 0, 60 * 60 * 365, false) // Cookie発行
    applySidebarSize(sidebarMin)
  })
}

// サイドバーの収縮を実行
function applySidebarSize(sidebarMin) {
  if (sidebarMin) {
    pageBase.classList.add('min')
  } else {
    pageBase.classList.remove('min')
  }
}
